<script>
export default {
  name: "Loading",
  props: {
    loading: {
      type: Boolean,
      required: true,
    },

    color: {
      type: String,
      default: 'teal darken-3'
    },

    widthCard: {
      type: Number,
      default: 100,
    },

    heightCard: {
      type: Number,
      default: 65,
    },

    widthProgress: {
      type: Number,
      default: 7
    },

    sizeProgress: {
      type: Number,
      default: 30,
    }
  }
}
</script>

<template>
  <div>
    <v-card
      v-if="loading"
      :min-height="`${heightCard}vh`"
      :width="`${widthCard}%`"
      class="d-flex align-center justify-center"
      flat
    >
      <v-progress-circular
        :size="sizeProgress"
        :width="widthProgress"
        :color="color"
        indeterminate
      >
      </v-progress-circular>
    </v-card>
    <slot v-else>
    </slot>
  </div>
</template>

<style scoped>

</style>